import React, { Component } from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import Helmet from "react-helmet"
import Fade from "react-reveal/Fade"
import { TINY_SHADOW, TINY_BKG, SECONDARY_TEXT } from "../components/consts/colors.js"

import "../css/index.css"
import "../css/typography.css"
import "../css/Hide.css"
import SectionContainer from "../components/SectionContainer"
import SectionContainerBackground from "../components/SectionContainerBackground"
import SectionHeaderContent from "../components/SectionHeaderContent"
import SectionContent from "../components/SectionContent"
import { TinyButton, TinyButtonAlt, TinyButtonWhite } from "../components/Button.js"
import SectionImages from "../components/SectionImages"
import SectionImage from "../components/SectionImage"
import FAQHeader from "../components/FAQHeader"
import arrow from "../assets/arrow.png"

import withScreensize from "../components/withScreensize"
import ScreensizeProvider from "../components/ScreensizeProvider"

const pageData = {
  FAQHeadline: "Check out our Demo Store!",
  FAQCopy: "We set this up to help you get a better idea to idea of what your store can look like!",
  FAQLink: "https://my.tinymerch.com",
  FAQwhatIsCTA: "Get Started!"
}

const DemoPrompt = styled.div`
  display: flex;
  width: 60%;
  img {
    position: absolute;
    bottom: 100px;
    right: 100px;
    width: 300px;
  }
  @media screen and (max-width: 768px) {
    img {
      display: none;
    }
  }
`

class _Demo extends Component {
  componentDidMount() {
    document.body.className = "Demo"
  }

  componentWillUnmount() {
    document.body.className = ""
  }

  render() {
    const { props } = this
    const isMobile = props.screensize === "phones"
    const isTablet = props.screensize === "thatUglyInBetweenSize"
    const isSmall = props.screensize === "devWithConsoleOpen"
    const isWidescreen = props.screensize === "widescreenFools"

    return (
      <div>
        <Helmet title="TinyMerch | FAQ – What is TinyMerch" />
        <SectionContainer justify="flex-start" align="flex-start">
          <SectionContent
            justify={isMobile ? "flex-start" : isTablet ? "flex-start" : "center"}
            align="flex-start"
            color
            height="90vh"
            width={isMobile ? "95%" : isTablet ? "80%" : isWidescreen ? "40%" : "50%"}
          >
            <h3 style={{ fontWeight: "400" }}>👋 Hi everyone,</h3>
            <h1>{pageData.FAQHeadline}</h1>
            <p>{pageData.FAQCopy}</p>
            <p>It's also here to sell cool TinyMerch merch! 😜</p>
            <a href={pageData.FAQLink}>
              <TinyButton>{pageData.FAQwhatIsCTA}</TinyButton>
            </a>
          </SectionContent>
          <DemoPrompt>
            <img src={arrow} />
          </DemoPrompt>
        </SectionContainer>
      </div>
    )
  }
}

const Demo = withScreensize(_Demo)

export default props => (
  <ScreensizeProvider>
    <Demo {...props} />
  </ScreensizeProvider>
)



// WEBPACK FOOTER //
// ./src/pages/demo.js